import React from 'react';
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext'

import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid

import { useState } from 'react';

export const TestActivity = () => {

let {
    scrollRef,
    //changeLanguage,
  } = React.useContext(StatusContext);
  
  let {
    testactivity
  } = React.useContext(AITestContext);

    
  // eslint-disable-next-line
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Name',
      valueGetter: (p) => p.data.name,
      flex: 2,
    },
    {
      field: 'Earning',
      valueFormatter: (p) => '$' + Math.floor(p.data.earning).toLocaleString(),
      flex: 1,
    },
    {
      field: 'Count',
      valueGetter: (p) => p.data.count,
      flex: 1,
    },
    {
      field: 'Last purchase',
      valueGetter: (p) => p.data.lastpurchasedate,
      flex: 1,
    },

  
  ]);

 
  
/*
  const [rowData, setRowData] = useState([
    { make: 'Tesla', model: 'Model Y', price: 64950, electric: true },
    { make: 'Ford', model: 'F-Series', price: 33850, electric: false },
    { make: 'Toyota', model: 'Corolla', price: 29600, electric: false },
    { make: 'Mercedes', model: 'EQA', price: 48890, electric: true },
    { make: 'Fiat', model: '500', price: 15774, electric: false },
    { make: 'Nissan', model: 'Juke', price: 20675, electric: false },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Make & Model',
      valueGetter: (p) => p.data.make + ' ' + p.data.model,
      flex: 2,
    },
    {
      field: 'price',
      valueFormatter: (p) => '£' + Math.floor(p.value).toLocaleString(),
      flex: 1,
    },
    { field: 'electric', flex: 1 },
    { field: 'button', cellRenderer: CustomButtonComponent, flex: 1 },
  ]);
  */

  return (
    <div>
     
      <div className="aitestActivityResponse" ref = {scrollRef}> 
        <div style={{ width: '100%', height: '100%' }}>
          <div style={{ width: '100%', height: '100%' }}
            className="ag-theme-quartz" >
            <AgGridReact rowData={testactivity} columnDefs={columnDefs} />
          </div>
        </div>
      </div> 
    </div>
  );
};
